import click from '@mailobj-browser/front/js/events/types/click.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import { elements } from '../../../styles.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: async (
    button
  ) => {
    const options = one(`.${elements.send_options}`, button.closest(`.${elements.send_form}`))

    options.classList.toggle('ea_mail__send_options-open')
  }
})

export default button => {
  onClick.listen(button)
}